import React, { Component } from 'react';

import ScoreBar from './components/ScoreBar';

import './ScoreList.scss';

const averageScore = (entry) => {
  if (entry.children.length === 0) return 'N/A';

  return Math.round(entry.children.reduce((acc, cur) => {
    return acc + parseFloat(cur.skill_scores.reduce((acc2, cur2) => {
      return acc2 + parseFloat(cur2.skill_score);
    }, 0));
  }, 0) / entry.children.length);
};

const getColour = (score) => {
  if (isNaN(score) === false && typeof score === 'number' && score !== 'N/A') {
    if (score < 33) {
      return '#d9534f';
    } else if (score < 66) {
      return '#f0ad4e';
    } else {
      return '#5cb85c';
    }
  } else {
    return '#0275d8';
  }
};

class ScoreList extends Component {
  render () {
    return (
      <div className='student-report-score-list'>
        <div className='container'>
          <div className='row mobile-sticky'>
            <div className='col'>
              <div className='student-report-score-list__title'>
                <h2>How You Scored</h2>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <div className='student-report-score-list__list'>
                {this.props['student-report-data'].scores.map((entry, index) => (
                  <div className='row student-report-score-list__entry' key={entry.id}>
                    <div className='col-md-5'>
                      <div className='student-report-score-list__entry-summary'>
                        <h5 className='student-report-score-list__entry-title'>{entry.skill_name}</h5>
                        <p className='student-report-score-list__score'><span style={{ color: getColour(averageScore(entry)) }}>{averageScore(entry) || 'N/A'}</span></p>
                        <p className='student-report-score-list__score-fraction'>out of 100</p>
                        <p className='student-report-score-list__description'>{entry.skill_description}</p>
                      </div>
                    </div>
                    <div className='col-md-7'>
                      {entry.children.map((score) =>
                        <ScoreBar entry={score} key={score.id} />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ScoreList;



// WEBPACK FOOTER //
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/ScoreList/index.js